module.exports = "/_next/static/images/UnifyCustomerProfile-dd320522792768947e5171cb26550bb8.png";